/**
 * 存储该账号下的分类仓库
 */

import { defineStore } from 'pinia';
import { store } from '@/store';
import { categoryStore } from './types/categoryStore';
import { GetShopCategorys } from '@/api/shop/type';
import { getShopCategorysApi } from '@/api/shop';

export const useCategoryStore = defineStore({
  id: 'app-categorys',
  state: (): categoryStore => ({
    allList: [],
    saveCode: 1,
  }),
  getters: {
    /**
     * 获取一级分类 不包含child属性
     */
    getFirst: (state) => {
      return state.allList.map((item) => {
        return {
          level: item.level,
          id: item.id,
          english: item.english,
        };
      });
    },
    /**
     * 获取全部分类数据
     */
    getAll: (state) => {
      return state.allList;
    },
    getSaveCode: (state) => {
      return state.saveCode;
    },
  },
  actions: {
    setSaveCode(num) {
      this.saveCode = num;
    },
    /**
     * 存储数据
     * @param list 分类列表
     */
    setData(list: Array<GetShopCategorys>) {
      if (list?.length) {
        this.allList = list;
      }
    },
    /**
     * 通过一级分类id获取其所有子分类
     * @param {string} id 一级分类id
     */
    getChildDataById(id: string): Array<GetShopCategorys> {
      const data = this.allList.filter((item) => item.id === id);
      if (data.length) {
        return data[0].child || [];
      } else {
        return [];
      }
    },
    /**
     * 初始化数据
     * 请求接口，并将数据存储到store中
     */
    async initData() {
      const result = await this.requestData();
      this.setData(result);
      return result;
    },
    /**
     * 发送请求获取数据
     */
    async requestData(): Promise<Array<GetShopCategorys>> {
      try {
        const result = await getShopCategorysApi();
        return result;
      } catch (e) {
        window['$message'].error('error');
        return Promise.reject(e);
      }
    },
  },
});

// Need to be used outside the setup
export function useCategoryStoreWidthOut() {
  return useCategoryStore(store);
}
